import {makeKey,update} from '../../../../utils/reducerOperations';
export function filterAggregationStarted(state, payload) {
    return makeKey(
        'filterAggregationApi',
        update(state.filterAggregationApi, {isProcessing: true})
    );
}